module.exports = __webpack_public_path__ + "static/img/ppt.e8eb5d24.png";